<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="back-box" v-if="!isEmbed">
        <div @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="btn-right-side mb10">
        <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增其他跟进</el-button>
      </div>
      <el-table v-loading="listLoading" :data="list" border>
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column label="跟进类型" align="center" width="120">
          <template slot-scope="{row}">
            {{ getCategoryName(row.followUpCategoryId) }}
          </template>
        </el-table-column>
        <el-table-column label="跟进方式" align="center" width="100">
          <template slot-scope="{row}">
            {{ row.followUpType == 1 ? '线下会面' : row.followUpType == 2 ? '线上沟通' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="跟进目的" prop="followUpPurpose" align="center" show-overflow-tooltip />
        <el-table-column label="跟进内容" prop="followUpContent" align="center" show-overflow-tooltip />
        <el-table-column label="跟进结果" prop="followUpResult" align="center" show-overflow-tooltip />
        <el-table-column label="给客户的承诺" prop="customerPromise" align="center" show-overflow-tooltip />
        <el-table-column label="跟进时间" prop="followUpTime" align="center" width="160" />
        <el-table-column label="下次跟进时间" prop="nextFollowUpTime" align="center" width="160" />
        <el-table-column label="跟进人" prop="createdBy" align="center" width="100" />
        <el-table-column label="创建时间" prop="createdTime" align="center" width="160" />
        <el-table-column label="操作" align="center" fixed="right" width="140">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" style="color: #f56c6c" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="跟进类型" prop="followUpCategoryId">
          <el-select v-model="form.followUpCategoryId" placeholder="请选择跟进类型" style="width: 100%">
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-if="item.enable == '1' || item.enable === true"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="跟进方式" prop="followUpType">
          <el-select v-model="form.followUpType" placeholder="请选择跟进方式" style="width: 100%">
            <el-option label="线下会面" :value="1" />
            <el-option label="线上沟通" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="跟进目的" prop="followUpPurpose">
          <el-input v-model="form.followUpPurpose" type="textarea" :rows="3" placeholder="请输入跟进目的" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="跟进内容" prop="followUpContent">
          <el-input v-model="form.followUpContent" type="textarea" :rows="3" placeholder="请输入跟进内容" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="跟进结果" prop="followUpResult">
          <el-input v-model="form.followUpResult" type="textarea" :rows="3" placeholder="请输入跟进结果" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="给客户的承诺" prop="customerPromise">
          <el-input v-model="form.customerPromise" type="textarea" :rows="2" placeholder="请输入给客户的承诺" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="客户基础信息" prop="customerBasicInfo">
          <el-input v-model="form.customerBasicInfo" type="textarea" :rows="2" placeholder="请输入客户基础信息" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="跟进图片" prop="followUpUrl">
          <more-image-upload v-model="followUpUrlList" :limit="9" fileTxt="上传附件" />
        </el-form-item>
        <el-form-item label="跟进时间" prop="followUpTime">
          <el-date-picker
            v-model="form.followUpTime"
            type="datetime"
            placeholder="请选择跟进时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="下次跟进时间" prop="nextFollowUpTime">
          <el-date-picker
            v-model="form.nextFollowUpTime"
            type="datetime"
            placeholder="请选择下次跟进时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import otherFollowCustRecordApi from '@/api/client/otherFollowCustRecord'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
import MoreImageUpload from '@/components/MoreImageUpload'

export default {
  components: { Pagination, MoreImageUpload },
  props: {
    // 嵌入模式（用于detail.vue中tab内嵌入），传入customerId
    customerId: {
      type: [Number, String],
      default: null
    },
    isEmbed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      query: {
        pageNo: 1,
        pageSize: 10,
        customerId: null
      },
      categoryList: [],
      dialogVisible: false,
      dialogTitle: '新增其他跟进',
      submitLoading: false,
      followUpUrlList: [],
      form: {
        id: null,
        customerId: null,
        followUpCategoryId: null,
        followUpType: null,
        followUpPurpose: '',
        followUpContent: '',
        followUpResult: '',
        customerPromise: '',
        customerBasicInfo: '',
        followUpUrl: '',
        followUpTime: null,
        nextFollowUpTime: null
      },
      rules: {
        followUpCategoryId: [{ required: true, message: '请选择跟进类型', trigger: 'change' }],
        followUpPurpose: [{ required: true, message: '请输入跟进目的', trigger: 'blur' }],
        followUpTime: [{ required: true, message: '请选择跟进时间', trigger: 'change' }]
      }
    }
  },
  created() {
    // 从路由参数或props获取customerId
    const cid = this.customerId || this.$route.query.customerId
    if (cid) {
      this.query.customerId = cid
    }
    this.loadCategoryList()
    this.doQueryList()
  },
  methods: {
    // 加载跟进类型列表
    loadCategoryList() {
      sysDataconstantApi.fetchCode({ code: 'addfollowCustRecordType' }).then(({ data }) => {
        if (data && data.content) {
          const content = data.content.trim()
          if (content.startsWith('[')) {
            this.categoryList = JSON.parse(content)
          } else {
            this.categoryList = content.split(',').map(s => s.trim()).filter(Boolean)
          }
        } else {
          this.categoryList = []
        }
      }).catch(() => {
        this.categoryList = []
      })
    },
    // 根据ID获取跟进类型名称
    getCategoryName(id) {
      if (!id) return ''
      if (this.categoryList.length === 0) return id
      if (typeof this.categoryList[0] === 'string') {
        const idx = Number(id)
        return (idx >= 0 && idx < this.categoryList.length) ? this.categoryList[idx] : id
      }
      const item = this.categoryList.find(c => String(c.id) === String(id))
      return item ? item.name : id
    },
    // 查询列表
    doQueryList({ pageNo, pageSize } = {}) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.listLoading = true
      otherFollowCustRecordApi.fetchList(this.query).then(({ data }) => {
        this.list = data.list || []
        this.total = data.total || 0
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 新增
    handleCreate() {
      this.dialogTitle = '新增其他跟进'
      this.form = {
        id: null,
        customerId: this.query.customerId,
        followUpCategoryId: null,
        followUpType: null,
        followUpPurpose: '',
        followUpContent: '',
        followUpResult: '',
        customerPromise: '',
        customerBasicInfo: '',
        followUpUrl: '',
        followUpTime: null,
        nextFollowUpTime: null
      }
      this.followUpUrlList = []
      this.dialogVisible = true
    },
    // 编辑
    handleUpdate(row) {
      this.dialogTitle = '编辑其他跟进'
      this.form = {
        id: row.id,
        customerId: row.customerId,
        followUpCategoryId: row.followUpCategoryId,
        followUpType: row.followUpType,
        followUpPurpose: row.followUpPurpose || '',
        followUpContent: row.followUpContent || '',
        followUpResult: row.followUpResult || '',
        customerPromise: row.customerPromise || '',
        customerBasicInfo: row.customerBasicInfo || '',
        followUpUrl: row.followUpUrl || '',
        followUpTime: row.followUpTime || null,
        nextFollowUpTime: row.nextFollowUpTime || null
      }
      this.followUpUrlList = (row.followUpUrl || '').split(',').filter(u => u).map(u => ({ url: u, name: u }))
      this.dialogVisible = true
    },
    // 删除
    handleDelete(row) {
      this.$common.confirm('确认删除该跟进记录吗？').then(() => {
        otherFollowCustRecordApi.deleteById(row.id).then(() => {
          this.$common.showMsg('success', '删除成功')
          this.doQueryList()
        })
      }).catch(() => {})
    },
    // 提交表单
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        this.form.followUpUrl = this.followUpUrlList.map(f => f.url).join(',')
        const api = this.form.id ? otherFollowCustRecordApi.update : otherFollowCustRecordApi.save
        api(this.form).then(() => {
          this.$common.showMsg('success', this.form.id ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.doQueryList()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },
    // 重置表单
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    // 返回
    handleBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.back-box {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
  color: #606266;
  &:hover {
    color: #409EFF;
  }
  i {
    margin-right: 4px;
  }
}
.btn-right-side {
  display: flex;
  justify-content: flex-end;
}
</style>
